import { render, staticRenderFns } from "./resourceMergeDialog.vue?vue&type=template&id=3cde0213&scoped=true"
import script from "./resourceMergeDialog.vue?vue&type=script&lang=js"
export * from "./resourceMergeDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceMergeDialog.vue?vue&type=style&index=0&id=3cde0213&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde0213",
  null
  
)

export default component.exports